import { AxiosInstance } from 'axios'

export async function getMe(axios: AxiosInstance) {
  const response = await axios.get('/v1/users/me')
  return response.data
}

export function getUserList(axios: AxiosInstance, params: Object) {
  return axios({
    url: '/v1/users',
    method: 'get',
    params: params,
  })
}
